import Stack from '@mui/material/Stack';

import { BrandSymbol } from '@/components/Loaders/BrandSymbol';

/** Full-page wait while a route resolves the session; same symbol as the boot loader. */
const PageLoader = () => (
  <Stack role="status" alignItems="center" justifyContent="center" sx={{ minHeight: '100dvh' }}>
    <BrandSymbol size={48} animation="print" />
  </Stack>
);

export default PageLoader;
